import { CallContext } from '@/context/call-context/call-context.tsx';
import { useContext } from 'react';

export const useCall = () => {
  const context = useContext(CallContext);
  if (!context) {
    throw new Error('useCall must be used within a CallProvider');
  }
  return context;
};
